import { ReactNode, useState } from "react";
import useDialogHooks from "../../../../../../Components/Dialog/dialog-hooks";
import { IUserDrawerList } from "../../../../../../Interfaces/componentTypes";
import { useGeneralHooks } from "../../../../../../Hooks/hooks";
import SettingsDialog from "../../../../../../Components/Dialog/DialogContents/UserProfile/Settings/settingsDialog";
import BusinessDataDialog from "../../Dialogs/BusinessDataDialog/businessDataDialog";
import { ICompanyResponse } from "../../../../../../Interfaces/responseTypes";
import DeleteCompanyDialog from "../../../../../../Components/Dialog/DialogContents/Business/DeleteCompany/deleteCompanyDialog";
import {  Settings, Account, EditData, Trash } from "../../../../../../Assets/Icons";

const useRestaurantDrawer = (data: ICompanyResponse, onUpdate: () => void) => {
    const { open, onOpen, onClose } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode>(<></>);
    const { t, navigate } = useGeneralHooks();

    const businnesItems:IUserDrawerList = [
        {
            title: t('My_Business.Business_Data'),
            icon: EditData,
            onClick: () => {
                onOpen();
                setDialogComponent(
                    <BusinessDataDialog
                        data={data}
                        onUpdate={onUpdate}
                        onCloseDialog={onClose}
                    />)
            }
        },
        {
            title: t('Business.Remove'),
            icon: Trash,
            onClick: () => {
                onOpen();
                setDialogComponent(
                    <DeleteCompanyDialog
                       businessName={data.name}
                       businessId={data.id}
                       onClose={onClose}
                       cb={()=>navigate("/home?tab=business")}
                    />)
            }
        },
    ]

    const drawerItems: IUserDrawerList = [
        {
            title: t('My_Business.My_Account'),
            icon: Account,
            onClick: () => {
                navigate('/home')
            }
        },
        {
            title: t('Home.User_Drawer.Settings'),
            icon: Settings,
            onClick: () => {
                onOpen();
                setDialogComponent(<SettingsDialog onClose={onClose} />)
            }
        },
    ];


    return {
        open,
        drawerItems,
        businnesItems,
        dialogComponent,
        onClose,
    }

};

export default useRestaurantDrawer